import { MdxDiv } from '@features/mdx/MdxDiv';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: '2ea08d75-43ee-4ee5-aa55-7681112f37be',
	[AppLanguageCodes.SK]: '2ea08d75-43ee-4ee5-aa55-7681112f37be',
	[AppLanguageCodes.DE]: '2ea08d75-43ee-4ee5-aa55-7681112f37be',
}


export const TextBox = () => {

	return (
		<MdxDiv className='text-box' articleIds={articleIds}>
		</MdxDiv>
	);
};